.progress {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: minmax(0, 1fr);
  gap: 6px;
}

/* The bar of steps that can be chosen keeps its gaps narrow, so six 44px
 * targets fit a 320px phone's 288px column: 6 × 44.7px + 5 × 4px (#159). */
.steps {
  gap: 4px;
}

.segment {
  height: 10px;
  border: var(--outline);
  border-radius: 999px;
  background: var(--surface);
}

.done {
  background: var(--accent);
}

/* A step that can be chosen (#148): a pill large enough to tap, holding its
 * step's icon in the ink colour of the theme. Done steps are filled, the
 * current one is also ringed, and steps to come stay outlined. */
.step {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 3px;
  height: 44px;
  padding: 0;
  color: var(--ink);
  cursor: pointer;
}

.step.done {
  color: var(--accent-ink);
}

/* Held while the step on screen saves before moving (#158). */
.step:disabled {
  cursor: progress;
  opacity: 0.6;
}

.current {
  box-shadow: inset 0 0 0 2px var(--ink);
}

.step:focus-visible {
  outline: 2px solid var(--ink);
  outline-offset: 2px;
}

.icon {
  display: block;
  width: 20px;
  height: 20px;
  background-color: currentColor;
  -webkit-mask: var(--icon) no-repeat center / contain;
  mask: var(--icon) no-repeat center / contain;
}

/* Two icons in one step are a little smaller, joined by a short dash of the
 * same ink, so the pair fits a phone's pill with room on either side. */
.dash {
  display: block;
  flex: 0 0 auto;
  width: 6px;
  height: 2px;
  border-radius: 1px;
  background-color: currentColor;
}

.dash ~ .icon,
.icon:has(+ .dash) {
  width: 18px;
  height: 18px;
}

/* On the narrowest phones the pill's content box is about 40.7px, so the
 * pair shrinks to fit inside it: 16 + 2 + 4 + 2 + 16 = 40px (#159). */
@media (max-width: 359px) {
  .step {
    gap: 2px;
  }

  .dash {
    width: 4px;
  }

  .dash ~ .icon,
  .icon:has(+ .dash) {
    width: 16px;
    height: 16px;
  }
}

.mood {
  --icon: url('./mood.svg');
}

.anxiety {
  --icon: url('./anxiety.svg');
}

.irritability {
  --icon: url('./irritability.svg');
}

.sleep {
  --icon: url('./sleep.svg');
}

.weight {
  --icon: url('./weight.svg');
}

.medication {
  --icon: url('./medication.svg');
}

.check {
  --icon: url('./check.svg');
}

.name {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  white-space: nowrap;
}
